import { useLingui } from '@lingui/react/macro';
import type { RefObject } from 'react';

export function TermsAndConditionsDialog(props: {
	ref: RefObject<HTMLTableElement | null> | undefined;
	responsible: string;
	purpose: string;
	legitimacy: string;
	recipients: string;
	rights: string;
	additionalInfo: string;
}) {
	const { t } = useLingui();

	return (
		<table ref={props.ref}>
			<tbody>
				<tr>
					<td className="font-semibold">{t`Responsible`}</td>
					<td>{props.responsible}</td>
				</tr>
				<tr>
					<td className="font-semibold">{t`Purpose`}</td>
					<td>{props.purpose}</td>
				</tr>
				<tr>
					<td className="font-semibold">{t`Legitimacy`}</td>
					<td>{props.legitimacy}</td>
				</tr>
				<tr>
					<td className="font-semibold">{t`Recipients`}</td>
					<td>{props.recipients}</td>
				</tr>
				<tr>
					<td className="font-semibold">{t`Rights`}</td>
					<td>{props.rights}</td>
				</tr>
				<tr>
					<td className="font-semibold">{t`Additional information`}</td>
					<td style={{ whiteSpace: 'pre-line' }} dangerouslySetInnerHTML={{ __html: props.additionalInfo }} />
				</tr>
			</tbody>
		</table>
	);
}
